<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-input
          @input.native="onGroupsSearch"
          v-model="search"
          class="input--200"
          type="search"
          placeholder="Search by number"
          name="search"
        />
        <app-select
          @input="onChangeFilter"
          v-model="category_filter"
          :options="category_options"
          :reduce="item => item.id"
          placeholder="Category"
          class="select--200"
        />
        <app-select
          @input="onChangeFilter"
          v-model="brand_filter"
          :options="brand_options"
          :reduce="item => item.id"
          placeholder="Brand"
          class="select--200"
        />
        <app-select
          @input="onChangeFilter"
          v-model="size_filter"
          :options="size_options"
          :reduce="item => item.id"
          placeholder="Size"
          class="select--200"
        />
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__item><div class="table-default__left">Item</div></template>
        <template #item="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'rental-items-detail', params: {id: row.id }}" class="table-default__link-border">
              {{ row.number }} - {{ row.category ? `${row.category.name} | ` : '' }}{{ row.brand ? `${row.brand.name} | ` : '' }}{{ row.color ? `${row.color.name} | ` : '' }}{{ row.size ? `${row.size.name}` : '' }}
            </router-link>
          </div>
        </template>
        <template #condition="{ row }">
          <div class="conditions">
            <span
              v-for="item of 5"
              :key="item"
              class="conditions__item"
              :class="{'conditions__item--checked': item <= row.condition}"
            />
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import {
  getEquipmentStorageBrand,
  getEquipmentStorageCategory,
  getEquipmentStorageItems,
  getEquipmentStorageSize,
} from '@/http'

export default {
  name: 'RentalItemsNeedRepair',
  data() {
    return {
      is_loaded: false,
      search: '',
      category_filter: '',
      brand_filter: '',
      size_filter: '',
      table: {
        items: [],
        columns: ['id', 'item', 'condition'],
        options: {
          headings: {
            id: 'ID',
            item: 'Client',
            condition: 'Condition',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      category_options: [],
      brand_options: [],
      size_options: [],
      table_preloader: false
    }
  },
  created() {
    this.fetchItems()
    getEquipmentStorageCategory().then(response => { this.category_options = response.data })
    getEquipmentStorageBrand().then(response => { this.brand_options = response.data })
    getEquipmentStorageSize().then(response => { this.size_options = response.data })
  },
  methods: {
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    fetchItems() {
      getEquipmentStorageItems({
        page: this.pagination.page,
        page_size: 20,
        status: 'repair',
        number: this.search,
        category: this.search ? '' : this.category_filter,
        brand: this.search ? '' : this.brand_filter,
        size: this.search ? '' : this.size_filter
      }).then(res => {
        this.table.items = res.data.results
        this.pagination.pages = res.data.pages
        this.pagination.count = res.data.count
        this.is_loaded = true
        this.table_preloader = false
      })
    },
    onChangeFilter() {
      this.search = ''
      this.pagination.page = 1
      this.fetchItems()
    },
    onGroupsSearch() {
      this.searchGroups(this)
    },
    searchGroups: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
    }, 350),
  }
}
</script>

